import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import ReceivingWorkStationDrawer from "../../../components/ReceivingWorkStationDrawer";
import PageHeader from "../../../components/PageHeader";
import { ConsolidationTracking } from "../../../components/PackageTracking";
import PackageSplit from "../../../components/PackageSplit";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import SelectConsolidatedPackage from "./SelectConsolidatedPackage";
import AllCondidatedOrders from "./AllConsolidatedOrders";
import Consolidate from "../shippingRequest/Consolidate";
import OrderHistory from "../../../components/common/History/OrderHistory";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { useDispatch, useSelector } from "react-redux";
import { calculateTotalValues } from "../shippingRequest/helper";
import { setActiveComponent, setPackages, setRequests, setSelectedPackage, setSelectedRequest, setActiveItem } from "../../../store/commonSlice";

const fetchPackageData = async (packageId) => {
  // console.log(editPackage?.packageTrackingId,collectionName, "data in EditPackageDrawer");
  if (packageId) {
    const docRef = doc(db, "shelfConsolidatedPackages", packageId);
    const querySnapshot = await getDoc(docRef);

    if (querySnapshot.exists()) {
      const data = { ...querySnapshot.data(), id: querySnapshot.id };
      return data;
    } else {
      return {};
    }
  } else {
    return {};
  }
};

const ConsolidatedShipping = () => {
  const { open } = useContext(SidebarContext);
  const dispatch = useDispatch();
  const { selectedPackage: packageActiveData, activeComponent } = useSelector((state) => state.common);
  // const [userActiveData, setUserActiveData] = useState({});
  // const [packageActiveData, setPackageActiveData] = useState({});
  const [selectedCollection, setSelectedCollection] = useState('shelfConsolidatedPackages')
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({ routePartnerId: "", warehouseId: "" })
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });
  const user = useSelector((state) => state.auth.value);

  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    dispatch(setActiveComponent('Chats'))
    dispatch(setSelectedPackage(item));
  };

  const historyClickHandler = async (id, item, e) => {
    e.stopPropagation();
    dispatch(setActiveComponent('History'))
    dispatch(setSelectedPackage(item));
  };

  const userClickHandler = async (id, item) => {
    setSelectedPackages([]);
    dispatch(setActiveComponent('Actions'))
    setSelectedCollection('shelfConsolidatedPackages');
    const consolidatedPackDetails = await fetchPackageData(item?.id);
    dispatch(setSelectedRequest(consolidatedPackDetails));
    dispatch(setSelectedPackage({...consolidatedPackDetails,isConsolidationPackage:true}));
    dispatch(setActiveItem(null));
    console.log(consolidatedPackDetails, "consolidatedPackDetails");

  };

  const packageClickHandler = async (id, item) => {
    dispatch(setActiveComponent('Actions'))
    dispatch(setSelectedPackage(item));
    setSelectedCollection('shelfPackages')
    dispatch(setActiveItem(null));
  };

  const closeHistoryHandler = () => {
    dispatch(setActiveComponent('Actions'))
  };

  const changeFilterHandler = (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    if (filter?.routePartnerId) {
      const querySnapshot = collection(db, "routePartnerMainAddress");

      const q = query(
        querySnapshot,
        where("routePartnerId", "==", filter.routePartnerId)
      );
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions((prev) => ({ ...prev, warehouses: arr }));
      });
    }
  };

  useEffect(() => {
    if (user?.routePartnerId) {
      setSelectedFilters((prev) => ({
        ...prev,
        routePartnerId: user?.routePartnerId,
      }));
      const querySnapshot = collection(db, "routePartnerMainAddress");

      const q = query(
        querySnapshot,
        where("routePartnerId", "==", user?.routePartnerId)
      );
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        console.log(arr, "arr in consolidate");

        setFilterOptions((prev) => ({ ...prev, warehouses: arr }));
      });
    }
  }, [user]);

  useEffect(() => {
    // handler();
    try {
      const querySnapshot = collection(db, "routePartners");
      const q = query(querySnapshot, where("isDeleted", "==", false));
      onSnapshot(q, (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions((prev) => ({ ...prev, routePartners: arr }));
      });
    } catch (err) {
      console.log(err, "err");
    }

    return () => {
      dispatch(setPackages([]))
      dispatch(setRequests([]))
    }
  }, []);

  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.packageShipmentCreationDate
        ? new Date(
          packageActiveData?.packageShipmentCreationDate?.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "-",
    },
    {
      label: "Packing",
      date: packageActiveData?.preparedShipmentDate
        ? new Date(
          packageActiveData?.preparedShipmentDate?.seconds * 1000
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : "-",
    },
    {
      label: "Send",
      date: "-",
    },
    { label: "Done", date: "-" },
  ];
  const activeStep = packageActiveData?.isPackageAddedToShipment ? 2 : 1;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        // width: {
        //   xl: open === true ? "calc(98vw - 240px)" : "96vw",
        // },
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <PageHeader
          pageTitle={"Consolidated Shipping"}
          selectedFilters={selectedFilters}
          filterOptions={filterOptions}
          changeFilterHandler={changeFilterHandler}
        />
      </Box>
      <Box sx={{ flex: 1, backgroundColor: "white" }}>
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllCondidatedOrders
              userClickHandler={userClickHandler}
              // userActiveData={userActiveData}
              selectedFilters={selectedFilters}
              chatClickHandler={chatClickHandler}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              borderRight: "1px solid #E5E5E8",
            }}
          >
            <SelectConsolidatedPackage
              // userActiveData={userActiveData}
              packageClickHandler={packageClickHandler}
              // packageActiveData={packageActiveData}
              setSelectedPackages={setSelectedPackages}
              selectedPackages={selectedPackages}
              historyClickHandler={historyClickHandler}
              chatClickHandler={chatClickHandler}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
              // overflowY: "auto",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{
                maxHeight: "88vh",
                ".simplebar-scrollbar": {
                  background: "red",
                },
              }}
              className="custom-scrollbar"
            >
              {activeComponent === "Chats" && (
                <OrderChats
                  // userActiveData={userActiveData}
                  packageActiveData={packageActiveData}
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "History" && (
                <OrderHistory
                  closeHistory={closeHistoryHandler}
                // packageActiveData={packageActiveData}
                />
              )}
              {activeComponent === "Actions" && (
                <ConsolidationTracking
                  steps={steps}
                  activeStep={activeStep}
                  selectedPackages={selectedPackages}
                />
              )}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ConsolidatedShipping;
